import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import {
  routes as authRoutes,
  registerGuards as registerAuthGuards,
} from "@/modules/auth/router/index";
import { routes as adminRoutes } from "@/modules/admin/router/index";
import { routes as organizationRoutes } from "@/modules/organization/router/index";
import { routes as rasRoutes } from "@/modules/ras/router/index";
import { routes as journalRoutes } from "@/modules/journal/router/index";
import { routes as settingsRoutes } from "@/modules/settings/router/index";
import { routes as analyticsRoutes } from "@/modules/analytics/router/index";
import { routes as helpRoutes } from "@/modules/help/router/index";
import { routes as pollRoutes } from "@/modules/poll/router/index";
import { routes as vacancyRoutes } from "@/modules/vacancy/router/index";
import { routes as profileRoutes } from "@/modules/profile/router/index";
import DbgApiTest from "../views/DbgApiTest.vue";
import Content from "../views/Content";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { isPublic: true },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  ...authRoutes,
  ...adminRoutes,
  ...organizationRoutes,
  ...rasRoutes,
  ...journalRoutes,
  ...settingsRoutes,
  ...analyticsRoutes,
  ...helpRoutes,
  ...pollRoutes,
  ...vacancyRoutes,
  ...profileRoutes,
  {
    path: "/dbgapitest",
    name: "DbgApiTest",
    component: DbgApiTest,
  },
  {
    path: "/content/:name",
    name: "Content",
    component: Content,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

registerAuthGuards(router);

export default router;
